// extracted by mini-css-extract-plugin
export default {"letter":"About_letter__tMjAJ"};